import getUrlQueryParams from '../getUrlQueryParams';
import { getSelectedLocations } from '../index';
import resolveGroupHighlightCode from '../resolveGroupHighlightCode';

export default (state) => {
  const group = getUrlQueryParams()?.groupHighlight;

  const selectedLocations = getSelectedLocations(state);

  if (!group) return false;
  if (selectedLocations.length < 2) return false;

  return resolveGroupHighlightCode(state, group);
};
